export default __webpack_public_path__ + "static/Banner_thewrap-8ee2eaa9ed4a4f7df6a78a50c8d8a828.mp4";